import React from 'react'
import PropTypes from 'prop-types'
import Markdown from 'react-markdown'

import { compose, getContext, withHandlers, withProps } from 'recompose'

import { OPTIMIZELY_REMOTE_STRINGS } from 'app-constants'

import { renderers } from './renderers'

type Props = {
  key: string
  fallbackValue: string
  raw?: boolean
  getRemoteString: (
    key: string,
    fallbackValue: string,
    raw?: boolean,
    flowOrFeature?: string,
  ) => string
}

export type RemoteStringsProps = Props

export const getRemoteStrings = (
  key: string,
  fallbackValue: string,
  flow: string,
  raw?: boolean,
) => {
  const stringsMap = new Map<string, any>(
    JSON.parse(window.sessionStorage.getItem(OPTIMIZELY_REMOTE_STRINGS)),
  )
  const flowStrings = stringsMap.get(flow)

  if (flowStrings && flowStrings.length > 0) {
    const dynamicString = flowStrings.filter(stringObject => stringObject.key === key)[0]
    return dynamicString && dynamicString.defaultValue ? (
      raw ? (
        dynamicString.defaultValue
      ) : (
        <Markdown source={dynamicString.defaultValue} renderers={renderers} />
      )
    ) : (
      fallbackValue
    )
  } else {
    return fallbackValue
  }
}

export default compose<Props, {}>(
  getContext({
    flow: PropTypes.string,
  }),
  withHandlers({
    getRemoteString: ({ flow }) => (
      key: string,
      fallbackValue: string,
      raw = false,
      flowOrFeature: string = flow,
    ) => {
      return getRemoteStrings(key, fallbackValue, flowOrFeature, raw)
    },
  }),
  withProps(({ getRemoteString }) => {
    return {
      getRemoteString,
    }
  }),
)
